import Timer from './Timer';
import Game from '../../../Game';
import { IGameState } from '../../../State/Game/IGameState';
import DateHelper from '../../../Utility/DateHelper';
import DailyLoginHelper from '../../../Utility/DailyLoginHelper';

export default class DailyLoginTimer extends Timer {
    private claimTime: Date;
    public duration = DateHelper.Day;

    constructor() {
        super();
        this.claimTime = DailyLoginHelper.getClaimWindows().lastClaimWindowEnd;
    }
    public complete(state: IGameState) {
        if (this.onComplete) {
            this.onComplete(state);
        }
        this.claimTime = DailyLoginHelper.getClaimWindows().lastClaimWindowEnd;
    }
    public isCompleted(state: IGameState): boolean {
        return DateHelper.isCompleted(this.getDate(), this.duration);
    }
    public onComplete: (state: IGameState) => unknown;
    public getDate(state: IGameState = Game.store.getState()): Date | null {
        return this.claimTime;
    }
}
